import React from 'react';
import { Helmet } from 'react-helmet';
import { businessInfo } from '../mockData';

const SEO = ({ 
  title, 
  description, 
  keywords = [],
  image,
  type = 'website',
  path = ''
}) => {
  const siteUrl = 'https://evolution-repairs.preview.emergentagent.com';
  const fullUrl = `${siteUrl}${path}`;
  const defaultImage = `${siteUrl}/og-image.jpg`;

  const defaultKeywords = [
    'cell phone repair El Paso',
    'phone repair El Paso TX',
    'iPhone repair El Paso',
    'Android repair El Paso',
    'laptop repair El Paso',
    'computer repair El Paso',
    'game console repair El Paso',
    'PlayStation repair El Paso',
    'Xbox repair El Paso',
    'screen repair El Paso',
    'battery replacement El Paso',
    'phone repair near me',
    'same day phone repair',
    'late night phone repair',
    'Evolution Cell Phone Repairs',
    '14900 William Meshel Dr',
    'El Paso TX 79938',
    'phone repair shop',
    'mobile device repair',
    'water damage repair',
    'charging port repair',
    'cracked screen repair',
    'Latino owned business El Paso',
    'LGBTQ friendly repair shop',
    'affordable phone repair',
    'fast phone repair',
    '2AM phone repair',
    'emergency phone repair'
  ];

  const allKeywords = [...new Set([...keywords, ...defaultKeywords])].join(', ');

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": businessInfo.name,
    "image": image || defaultImage,
    "telephone": businessInfo.phone,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "14900 William Meshel Dr",
      "addressLocality": "El Paso",
      "addressRegion": "TX",
      "postalCode": "79938",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 31.8,
      "longitude": -106.3
    },
    "url": siteUrl,
    "priceRange": "$$",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "02:00"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": businessInfo.rating,
      "reviewCount": businessInfo.reviewCount
    },
    "servesCuisine": "Electronics Repair",
    "description": description
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={allKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:site_name" content={businessInfo.name} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image || defaultImage} />

      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content={businessInfo.name} />
      <link rel="canonical" href={fullUrl} />

      {/* Local Business Schema */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
